export default __webpack_public_path__ + "static/media/ic-img1.85cb3d89.svg";